import { User } from "containers/Users/users.d";

export const renderUserLabel = (user?: User | null): string => {
  return user?.firstName && user?.lastName
    ? `${user?.firstName} ${user?.lastName}`
    : user?.email || "";
};
